module.exports = __webpack_public_path__ + "static/media/4XL.bb245ea2.jpg";